// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_si-0";